<template>
  <div>
      <el-card>
          <el-button type="primary" slot="header" size="medium"  @click="addList()" v-if="fatherPid.length === 1">{{$t('lang.btn_addUseristrators')}}</el-button>
          <el-button type="primary" slot="header" size="medium"  @click="raturnList()" v-if="fatherPid.length > 1">{{$t('lang.btn_returnUseristratorsList')}}</el-button>
        <el-table
          :data="tableData"
          class="wid100"
          :row-class-name="tableRowClassName"
          @selection-change="handleSelectionChange"
          :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        >
          <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
          <el-table-column
            type="index"
            :index="indexMethod" align="center"
            :label="$t('lang.lab_index')"
            width="100px"
          ></el-table-column>
          <el-table-column prop="deptName" :label="$t('lang.lab_deptName')"></el-table-column>
          <el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width4">
            <template slot-scope="scope">
              <el-button class="orange" @click="delete1(scope.row.id)">{{deletename}}</el-button>
              <el-button
                @click="seeUser(scope.row.id)"
                v-if="scope.row.isEnd === 0"
              >{{$t('lang.lab_seeUser')}}</el-button>
              <el-button
                @click="addUser(scope.row.id)"
                v-if="scope.row.isEnd === 0"
              >{{$t('lang.lab_addUser')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
        />
      </el-card>
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
      <el-scrollbar>
        <el-form ref="form" :model="form" :rules="rules" class="form_show" :label-width="require('@/config/enum').c_ws7" :label-suffix="require('@/config/enum').c_colon">
          <el-form-item :label="$t('lang.lab_isNew')" prop="isEnd">
            <el-radio v-model="form.isEnd" label="0">{{$t('lang.lab_have')}}</el-radio>
            <el-radio v-model="form.isEnd" label="1">{{$t('lang.lab_notHave')}}</el-radio>
          </el-form-item>
          <el-form-item :label="$t('lang.key_deptName')" prop="deptName">
            <el-input v-model="form.deptName" :placeholder="$t('lang.key_deptName')"></el-input>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" @click="save('form')" v-if="isNew === 0">{{$t('lang.btn_save')}}</el-button>
        <el-button
          type="primary"
          @click="addNewDept('form')"
          v-if="isNew === 1"
        >{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:useristratorsList
 *@Description:物业公司架构组织
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-16
 */
export default {
  data() {
    return {
      idSave: 0, // 保存id
      pageCount: 0, // 一共多少页 
      show: false, // 弹框开关
      changeTitle: '', // 弹框title
      pid: 0, // 存储id
      pageNum: 1, // 页数 
      pageSize: 10, // 每页显示数 
      tableData: [], // 列表
      isNew: 0, // 区分添加本级下级区别
      fatherPid: [0], // 记录父级pid的数组
      returnId: 0, // 返回上级部门的id
      newId: '', // 添加下级部门的父级部id
      multipleSelection: [], // 多选框
      form: {
        deptName: '',
        isEnd: '',
        pid: 0
      }, // 对象
      rules: {
        deptName: [
          { required: true, message: this.$i18n.t('lang.lab_inputDeptName'), trigger: 'blur' },
          { max: 10, message: this.$i18n.t('lang.lab_inputDeptNameTen'), trigger: 'blur' }
        ],
        isEnd: [
          { required: true, message: this.$i18n.t('lang.lab_depeIsEnd'), trigger: 'change' }
        ]
      }, // 表单验证
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      deletename: require('@/config/enum').deletename // 删除
    }
  },
  created() {
     this.idSave = localStorage.getItem('idSave') || 0
     this.fatherPid = JSON.parse(localStorage.getItem('fatherPid')) || [0]
    if (this.idSave === 0) {
       this.listShow()
      } else {
       this.seeUserpage()
      }
  },
  destroyed() {
    localStorage.setItem('idSave', 0)
    localStorage.setItem('fatherPid', JSON.stringify([0]))
  },
  methods: {
    // 监听关闭dialog
    handleDialogClosed() {
      this.form.isEnd = ''
      this.form.deptName = ''
      this.$refs.form.clearValidate()
    },
    // 返回上级部门
    raturnList() {
      this.pageSize = 10
      this.pageNum = 1
      this.idSave = this.fatherPid[this.fatherPid.length - 2]
      localStorage.setItem('idSave', this.idSave)
      this.$get(
        `/getOrgDepartmentListByPid/${this.fatherPid[this.fatherPid.length - 2]}?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          this.$message.error(error)
        }
      )
      let returnArr = []
      for (var i = 0; i < this.fatherPid.length - 1; i++) {
        returnArr.push(this.fatherPid[i])
      }
      this.fatherPid = returnArr
      localStorage.setItem('fatherPid', JSON.stringify(this.fatherPid))
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
     if (this.idSave === 0) {
       this.listShow()
      } else {
      this.seeUserpage()
      }
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      if (this.idSave === 0) {
       this.listShow()
      } else {
      this.seeUserpage()
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 用于翻页查看下级部门
    seeUserpage() {
      let loading = this.$loading()
      this.$get(
        `/getOrgDepartmentListByPid/${this.idSave}?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取部门列表
    listShow() {
      let loading = this.$loading()
      this.$get(
        `/getOrgDepartmentListByPid/${this.form.pid}?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
            this.form.pid = 0
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加本级新部门保存按下
    save(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
            let params = {
              isEnd: this.form.isEnd,
              pidList: this.form.pid,
              deptName: this.form.deptName,
            }
          let loading = this.$loading()
          this.$post(`/addOrgDepartment`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                this.listShow()
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 查看下级部门
    seeUser(id) {
      console.log(id)
      this.pageSize = 10
      this.pageNum = 1
      this.idSave = id
      localStorage.setItem('idSave', id)
      console.log(this.idSave + '7878')
      let loading = this.$loading()
      this.$get(
        `/getOrgDepartmentListByPid/${id}?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
            this.fatherPid.push(id)
          }
          localStorage.setItem('fatherPid', JSON.stringify(this.fatherPid))
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 重置弹框
    rest(form) {
      this.$refs[ form ].resetFields()
      this.form.isEnd = ''
      this.form.deptName = ''
    },
    // 添加下級部门
    addUser(id) {
      this.isNew = 1
      this.pid = id
      this.form.isEnd = ''
      this.form.deptName = ''
      this.changeTitle = this.$i18n.t('lang.lab_addUser')
      this.show = true
    },
    // 添加下级部门弹框按下确定
    addNewDept(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          let formData = new FormData()
          formData.append('isEnd', this.form.isEnd)
          formData.append('pidList', this.pid)
          formData.append('deptName', this.form.deptName)
          let params = {
              isEnd: this.form.isEnd,
              pidList: this.pid,
              deptName: this.form.deptName,
            }
          let loading = this.$loading()
          this.$post(`/addOrgDepartment`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.show = false
                let loading = this.$loading()
                this.$get(
                  `/getOrgDepartmentListByPid/${this.pid}?pageSize=${this.pageSize}&pageNo=${this.pageNum}`
                ).then(

                  res => {
                    loading.close()
                    if (res && res.errCode === 0) {
                      this.tableData = res.list
                      this.pageCount = res.pageCount
                      this.fatherPid.push(this.pid)
                    }
                    localStorage.setItem('fatherPid', JSON.stringify(this.fatherPid))
                  },
                  error => {
                    loading.close()
                    this.$message.error(error)
                  }
                )
              }
              setTimeout(() => {
                loading.close()
              }, 200)
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        } else {
          return false
        }
      })
    },
    // 添加本级新部门
    addList() {
      this.isNew = 0
      this.changeTitle = this.$i18n.t('lang.btn_addUseristrators')
      this.form.deptName = ''
      this.form.isEnd = ''
      this.show = true
    },
    // 删除
    delete1(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/delOrgDept/${id}/${this.form.pid}`).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.pageNum = 1
             if (this.idSave === 0) {
              this.listShow()
            } else {
             this.seeUserpage()
            }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    }
  }
}
</script>

<style lang="scss">

</style>